import { Navigate } from "react-router-dom";
import useStore from "hooks/useStore";

function RoleRoute({ allowedRoles, children }) {
  const isUserAdministrator = useStore((s) => s.isUserAdministrator)();
  const isUserPublic = useStore((s) => s.isUserPublic)();
  const isCompany = Boolean(!isUserAdministrator && !isUserPublic);

  const hasAccess =
    (allowedRoles.includes("admin") && isUserAdministrator) ||
    (allowedRoles.includes("company") && isCompany) ||
    (allowedRoles.includes("public") && isUserPublic);

  return hasAccess ? children : <Navigate to="/unauthorized" replace />;
}

export default RoleRoute;
